import { Select, Space, Tooltip, Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";

export default function ProductosFilters({
  productos = [],
  proyectos = [],
  municipios = [],
  pos = [],
  filters,
  onFilter,
  onClear,
  extra
}) {
  return (
    <Space
      style={{
        marginBottom: 16,
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
      }}
      wrap
    >
      {/* 🔍 FILTROS */}
      <Space wrap>
        <Select
          placeholder="Producto"
          style={{ width: 220 }}
          allowClear
          showSearch
          value={filters.producto}
          onChange={(v) => onFilter("producto", v)}
          options={productos.map(p => ({ label: p, value: p }))}
        />

        <Select
          placeholder="PO"
          style={{ width: 150 }}
          allowClear
          showSearch
          value={filters.po}
          onChange={(v) => onFilter("po", v)}
          options={pos.map(p => ({ label: p, value: p }))}
        />

        <Select
          placeholder="Municipio"
          style={{ width: 180 }}
          allowClear
          showSearch
          value={filters.municipio}
          onChange={(v) => onFilter("municipio", v)}
          options={municipios.map(m => ({ label: m, value: m }))}
        />

        <Select
          placeholder="Proyecto"
          style={{ width: 200 }}
          allowClear
          showSearch
          value={filters.proyecto}
          onChange={(v) => onFilter("proyecto", v)}
          options={proyectos.map(p => ({
            label: `${p.proyecto}`,
            value: p.codigo
          }))}
        />

        {/* 🔥 LIMPIAR */}
        <Tooltip title="Limpiar filtros">
          <Button icon={<ClearOutlined />} onClick={onClear}>
            Limpiar
          </Button>
        </Tooltip>
      </Space>

      {/* ⚡ ACCIONES */}
      <Space>{extra}</Space>
    </Space>
  );
}